var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19738_129622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 1H20.667C22.2248 1.00018 23.5 2.28414 23.5 3.88281V20.1172C23.5 21.7159 22.2248 22.9998 20.667 23H3.33301C1.77521 22.9998 0.5 21.7159 0.5 20.1172V3.88281C0.5 2.28414 1.77521 1.00018 3.33301 1Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.0763L16.2038 15.3916L14.2654 13.4246L13.4013 14.3015L15.3397 16.2684L14.0435 17.5836H17.5V14.0763ZM6.5 9.92917L7.79613 8.61391L9.7346 10.5809L10.5987 9.70404L8.66027 7.73707L9.95647 6.42188H6.5V9.92917ZM17.5 6.42188H14.0435L15.3397 7.73707L13.4013 9.70404L14.2654 10.5809L16.2038 8.61391L17.5 9.92917V6.42188ZM6.5 17.5836H9.95647L8.66027 16.2684L10.5987 14.3015L9.7346 13.4246L7.79613 15.3916L6.5 14.0763V17.5836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19738_129622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.0c3742ecf1b311190e7b9473c74bae37.svg";
export { ForwardRef as ReactComponent };